
const LocationAddressViewModel = Backbone.Model.extend({
	idAttribute: 'locationID',
	initialize: function() {
		this.set({
			address: new Backbone.Model(this.get('address'))
		});
	}
});

export default LocationAddressViewModel;
